import { Box, Card, Skeleton } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

const QuestionTemplateCardSkeleton = () => {
  return (
    <Box gap="s12">
      {times(4, (index) => (
        <Card key={index}>
          <Card.Content>
            <Box
              flexDirection="row"
              gap="s24"
              justifyContent="spaceBetween"
              alignItems="center"
              width="full"
            >
              <Skeleton height="s24" isLoading width="s24" />
              <Box gap="s8" flexDirection="column" width="full">
                <Skeleton height="s20" isLoading width="full" />
                <Skeleton height="s20" width="s120" isLoading />
              </Box>
              <Skeleton height="s24" isLoading width="s120" />
            </Box>
          </Card.Content>
        </Card>
      ))}
    </Box>
  )
}

export default QuestionTemplateCardSkeleton
